import {Flag} from 'platform/components';
import {Box, Heading, HStack, Icon, Show, Text, VStack} from 'platform/foundation';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {ServiceIntervalPlanCommentary} from '@dms/api/vehicle';
import i18n from '@dms/i18n';

import {Nullish, RequiredTestIdProps} from 'shared/web';

interface VehicleServiceIntervalCommentaryProps extends RequiredTestIdProps {
  commentary: ServiceIntervalPlanCommentary | Nullish;
}

export function VehicleServiceIntervalCommentary(props: VehicleServiceIntervalCommentaryProps) {
  return (
    <Box
      border="1px solid"
      borderColor="palettes.blue.20.100"
      borderRadius="small"
      backgroundColor="palettes.blue.10.100"
      padding={3}
      data-testid={props['data-testid']}
    >
      <HStack spacing={3} align="flex-start">
        <Box width={8} height={8} borderRadius="small" backgroundColor="palettes.blue.20.100">
          <HStack height="100%" justify="center" align="center">
            <Icon value="action/magic_wand" size={4} color="palettes.blue.70.100" />
          </HStack>
        </Box>
        <VStack spacing={2}>
          <Heading size={5}>{i18n.t('entity.vehicle.serviceIntervalPlan.commentaryTitle')}</Heading>
          {props.commentary?.summary.map((paragraph) => (
            <Text key={paragraph} size="xSmall" color="secondary">
              {paragraph}
            </Text>
          ))}
          <Show when={isNotNilOrEmpty(props.commentary?.actions)}>
            <HStack spacing={2} wrap>
              {props.commentary?.actions.map((action) => (
                <Flag key={action} label={action} colorScheme="blue" size="small" isSubtle />
              ))}
            </HStack>
          </Show>
        </VStack>
      </HStack>
    </Box>
  );
}
